import { __rest } from "tslib";
import React, { useState } from 'react';
import { Modal } from 'antd';
import { api, locationHelper } from 'api';
import { SIDE_BAR_WIDTH, TOOL_BAR_HEIGHT } from '@web-common/utils/constant';
import CloseIcon from '../Icons/svgs/CloseMailSvg';
import SiriusCheckbox from '@web-common/components/UI/SiriusContact/Checkbox';
import { ReactComponent as WarningIcon } from '@/images/icons/edm/warning.svg';
import styles from './SiriusModal.module.scss';
import { getIn18Text } from 'api';
const systemApi = api.getSystemApi();
export const modalProps = {
    isGlobal: false,
    cancelText: getIn18Text('QUXIAO'),
    okText: getIn18Text('QUEDING'),
    centered: true,
    destroyOnClose: true,
    maskClosable: true,
    closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }),
    wrapClassName: `${!locationHelper.testPathMatch('/') ? styles.modalWrapGlobal : !systemApi.isWebWmEntry() ? styles.modalWrap : ''}`,
    maskStyle: {
        background: 'rgba(0, 0, 0, 0.5)',
        left: `${!locationHelper.testPathMatch('/') ? 0 : !systemApi.isWebWmEntry() ? SIDE_BAR_WIDTH : 0}px`,
        top: `${!locationHelper.testPathMatch('/') ? 0 : !systemApi.inEdm() && !systemApi.isElectron() ? TOOL_BAR_HEIGHT : 0}px`,
    },
    globalMaskStyle: { background: 'rgba(0, 0, 0, 0.5)', left: 0 },
};
const OriginModal = props => {
    const { children, isGlobal = false, maskStyle, getContainer = false } = props, restProps = __rest(props, ["children", "isGlobal", "maskStyle", "getContainer"]);
    const _maskStyle = isGlobal ? modalProps.globalMaskStyle : modalProps.maskStyle;
    return (React.createElement(Modal, Object.assign({ getContainer: getContainer }, modalProps, restProps, { maskStyle: Object.assign(Object.assign({}, _maskStyle), maskStyle) }), children));
};
export const SiriusHtmlModal = props => {
    const { children, isGlobal = false, wrapClassName, maskStyle } = props, restProps = __rest(props, ["children", "isGlobal", "wrapClassName", "maskStyle"]);
    const _maskStyle = isGlobal ? modalProps.globalMaskStyle : modalProps.maskStyle;
    return (React.createElement(Modal, Object.assign({ keyboard: false, getContainer: false, bodyStyle: { padding: 0, margin: 0 }, footer: null }, modalProps, restProps, { maskStyle: Object.assign(Object.assign({}, _maskStyle), maskStyle) }), children));
};
const SiriusModal = OriginModal;
const handleSiriusModal = (props, type) => {
    let isChecked = false;
    if (props.needCheckContent) {
        props.content = (React.createElement(ModalCheckContent, { onCheck: (checked) => {
                isChecked = checked;
            } }, props.content));
        if (props.onOk) {
            const onOk = props.onOk;
            props.onOk = async () => {
                await onOk(isChecked);
            };
        }
    }
    if (props.hideCancel) {
        return Modal[type](Object.assign(Object.assign(Object.assign({}, modalProps), { icon: React.createElement("i", { className: `icon ${type}-icon` }) }), props));
    }
    if (props.title) {
        props.title = React.createElement("span", { "data-test-id": "global_toast_title" }, props.title);
    }
    if (props.content) {
        props.content = React.createElement("div", { "data-test-id": "global_toast_content" }, props.content);
    }
    props.cancelButtonProps = Object.assign(Object.assign({}, (props.cancelButtonProps || {})), { 'data-test-id': 'global_toast_left_btn' });
    props.okButtonProps = Object.assign(Object.assign({}, (props.okButtonProps || {})), { 'data-test-id': 'global_toast_right_btn' });
    return Modal.confirm(Object.assign(Object.assign(Object.assign({}, modalProps), { icon: React.createElement("i", { className: `icon ${type}-icon` }) }), props));
};
SiriusModal.info = (props) => {
    return handleSiriusModal(props, 'info');
};
SiriusModal.success = (props) => {
    return handleSiriusModal(props, 'success');
};
SiriusModal.error = (props) => {
    return handleSiriusModal(props, 'error');
};
SiriusModal.warning = (props) => {
    return handleSiriusModal(props, 'warning');
};
const ModalCheckContent = ({ onCheck, children }) => {
    const [checked, setChecked] = useState(false);
    return (React.createElement("div", { className: styles.modalCheckContentWrap, "data-test-id": "global_toast_content_checkbox", "data-test-check": checked, onClick: () => {
            setChecked(b => !b);
            onCheck(!checked);
        } },
        React.createElement("div", { className: styles.checkboxWrap },
            React.createElement(SiriusCheckbox, { checked: checked })),
        React.createElement("div", { className: styles.contentWrap }, children)));
};
SiriusModal.confirm = (props) => {
    return handleSiriusModal(props, 'confirm');
};
SiriusModal.confirmError = (props) => {
    props.icon = (React.createElement("span", { className: styles.confirmErrorIcon },
        React.createElement(WarningIcon, null)));
    props.className = `${props.className} ${styles.confirmError}`;
    return handleSiriusModal(props, 'confirm');
};
export default SiriusModal;
